import React, { useState } from "react";
import { Box, Typography, Button, IconButton, Tooltip, TextField, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import DataTable from "../components/DataTable";
import SearchIcon from "@mui/icons-material/Search";
const districts = ["Erode", "Coimbatore", "Salem", "Namakkal", "Karur"];
const states = ["Tamil Nadu"];
export default function Users() {
    const [users, setUsers] = useState([]);
    const [open, setOpen] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const usersList = [
        { name: "John Doe", mobile: "9876543210", city: "Erode", district: "Erode" },
        { name: "Jane Smith", mobile: "9876543211", city: "Coimbatore", district: "Coimbatore" },
        { name: "Alice", mobile: "9876543212", city: "Salem", district: "Salem" }
    ];
    const plansList = [
        { name: "Gold Plan", duration: "12 Months", price: 50000, benefits: "Gold daily rates + special discount" },
        { name: "Silver Plan", duration: "6 Months", price: 20000, benefits: "Silver daily rates + some discount" }
    ];
    const [openCustomerModal, setOpenCustomerModal] = useState(false);
    const [openPlanModal, setOpenPlanModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);
    const [assignedPlan, setAssignedPlan] = useState(null);
    const [form, setForm] = useState({ name: "", mobile: "", address1: "", address2: "", town: "", city: "", district: "Erode", state: "Tamil Nadu", country: "India", pincode: "", password: "", profile: null });
    const openAdd = () => {
        setForm({ name: "", mobile: "", address1: "", address2: "", town: "", city: "", district: "Erode", state: "Tamil Nadu", country: "India", pincode: "", password: "", profile: null });
        setEditIndex(null);
        setOpen(true);
    };
    const openEdit = (index) => {
        setForm(users[index]);
        setEditIndex(index);
        setOpen(true);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };
    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setForm({ ...form, profile: { file, url: URL.createObjectURL(file) } });
    };
    const handleSave = () => {
        if (!form.name || !form.mobile) {
            alert("Please fill required fields");
            return;
        }
        if (editIndex !== null) {
            const updated = [...users];
            updated[editIndex] = form;
            setUsers(updated);
        } else {
            setUsers([...users, form]);
        }
        setOpen(false);
    };
    const deleteUser = (index) => {
        const updated = users.filter((_, i) => i !== index);
        setUsers(updated);
    };
    const filteredUsers = usersList.filter(
        u => u.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            u.mobile.includes(searchTerm)
    );
    const customerColumns = ["S.No", "User Name", "Mobile", "City", "District", "Action"];
    const customerRows = filteredUsers.map((u, i) => [i + 1, u.name, u.mobile, u.city, u.district,
    <Button variant="contained" onClick={() => { setSelectedUser(u); setOpenPlanModal(true); }}>Assign</Button>
    ]);
    const planColumns = ["S.No", "Plan Name", "Duration", "Price (₹)", "Benefits", "Action"];
    const planRows = plansList.map((p, i) => [i + 1, p.name, p.duration, p.price.toLocaleString(), p.benefits,
    <Button variant="contained" onClick={() => { setAssignedPlan(p); setOpenPlanModal(false); setOpenCustomerModal(false); alert(`Assigned ${p.name} to ${selectedUser.name}`); }}>Select</Button>
    ]);
    const columns = ["S.No", "User Name", "Mobile", "City", "District", "Profile", "Action"];
    const rows = users.map((u, i) => [i + 1, u.name, u.mobile, u.city, u.district,
    <Box> {u.profile && (<img src={u.profile.url} alt="" width="40" style={{ borderRadius: "50%" }} />)}</Box>,
    <Box>
        <Tooltip title="Edit">
            <IconButton color="primary" onClick={() => openEdit(i)}>
                <EditIcon />
            </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
            <IconButton color="error" onClick={() => deleteUser(i)}>
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    </Box>
    ]);
    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 500 }}>Users</Typography>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2, gap: 2 }}>
                <Button variant="contained" startIcon={<AddIcon />} onClick={() => setOpenCustomerModal(true)}>Assign Plan</Button>
                <Button variant="contained" startIcon={<AddIcon />} onClick={openAdd}>Add User</Button>
            </Box>
            <DataTable columns={columns} rows={rows} loading={false} />
            {open && (
                <Box sx={{ position: "fixed", top: 50, left: 0, width: "100%", height: "100%", bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1200 }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 1000, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>{editIndex !== null ? "Edit User" : "Add User"}</Typography>
                        <TextField label="User Name" name="name" fullWidth value={form.name} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Mobile Number" name="mobile" fullWidth value={form.mobile} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Address Line 1" name="address1" fullWidth value={form.address1} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Address Line 2" name="address2" fullWidth value={form.address2} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Town" name="town" fullWidth value={form.town} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="City" name="city" fullWidth value={form.city} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField select label="District" name="district" fullWidth value={form.district} onChange={handleChange} sx={{ mb: 2 }}>
                            {districts.map((d) => (<MenuItem key={d} value={d}>{d}</MenuItem>))}
                        </TextField>
                        <TextField select label="State" name="state" fullWidth value={form.state} onChange={handleChange} sx={{ mb: 2 }}                        >
                            {states.map((s) => (<MenuItem key={s} value={s}>{s}</MenuItem>))}
                        </TextField>
                        <TextField label="Country" name="country" fullWidth value="India" disabled sx={{ mb: 2 }} />
                        <TextField label="Pin Code" name="pincode" fullWidth value={form.pincode} onChange={handleChange} sx={{ mb: 2 }} />
                        <TextField label="Password" name="password" type="password" fullWidth value={form.password} onChange={handleChange} sx={{ mb: 2 }} />
                        <Button variant="outlined" component="label">Upload Profile Picture<input hidden type="file" accept="image/*" onChange={handleImageUpload} /></Button>
                        <Box sx={{ mt: 2 }}>{form.profile && (<img src={form.profile.url} alt="" width="90" style={{ borderRadius: "50%" }} />)}</Box>
                        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 3 }}>
                            <Button onClick={() => setOpen(false)}>Cancel</Button>
                            <Button variant="contained" onClick={handleSave}>Save</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {openCustomerModal && (
                <Box sx={{
                    position: "fixed", top: 50, left: 0, width: "100%", height: "100%",
                    bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 1200
                }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 900, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>Select Customer</Typography>
                        <TextField
                            placeholder="Search by name or mobile"
                            fullWidth
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            sx={{ mb: 2 }}
                            InputProps={{ startAdornment: <SearchIcon /> }} />
                        <DataTable columns={customerColumns} rows={customerRows} loading={false} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button onClick={() => setOpenCustomerModal(false)}>Close</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {openPlanModal && selectedUser && (
                <Box sx={{
                    position: "fixed", top: 50, left: 0, width: "100%", height: "100%",
                    bgcolor: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 1300
                }}>
                    <Box sx={{ bgcolor: "#fff", p: 3, borderRadius: 2, width: 900, maxHeight: "75vh", overflowY: "auto" }}>
                        <Typography variant="h6" sx={{ mb: 2 }}>Select Plan for {selectedUser.name}</Typography>
                        <DataTable columns={planColumns} rows={planRows} loading={false} />
                        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                            <Button onClick={() => setOpenPlanModal(false)}>Close</Button>
                        </Box>
                    </Box>
                </Box>
            )}
            {assignedPlan && selectedUser && (
                <Box sx={{ mt: 2 }}>
                    <Typography><strong>{assignedPlan.name}</strong> assigned to <strong>{selectedUser.name}</strong></Typography>
                </Box>
            )}
        </Box>
    );
}